import { c as _c } from "react/compiler-runtime";
import { anyspendService } from "../../../anyspend/services/anyspend.js";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
export function useAnyspendOrderHistory(creatorAddress, t0, t1) {
  const $ = _c(11);
  const limit = t0 === undefined ? 100 : t0;
  const offset = t1 === undefined ? 0 : t1;
  let t2;
  if ($[0] !== creatorAddress || $[1] !== limit || $[2] !== offset) {
    t2 = {
      queryKey: ["getOrderHistory", creatorAddress, limit, offset],
      queryFn: async () => {
        const response = await anyspendService.getOrderHistory(creatorAddress, limit, offset);
        return response.data;
      }
    };
    $[0] = creatorAddress;
    $[1] = limit;
    $[2] = offset;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    data: t3,
    isLoading,
    refetch,
    error
  } = useQuery(t2);
  let t4;
  if ($[4] !== t3) {
    t4 = t3 === undefined ? [] : t3;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const rawData = t4;
  let t5;
  let t6;
  if ($[6] !== error || $[7] !== isLoading || $[8] !== rawData || $[9] !== refetch) {
    t6 = {
      orderHistory: rawData,
      isLoadingOrderHistory: isLoading,
      getOrderHistoryError: error,
      refetchOrderHistory: refetch
    };
    $[6] = error;
    $[7] = isLoading;
    $[8] = rawData;
    $[9] = refetch;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  t5 = t6;
  return t5;
}